import { type FC } from 'react';
import classnames from 'classnames';
import stylesheet from './TimeoutBar.scss';

type TimeoutBarProps = {
    className?: string;
    duration: number;
    inProgress: boolean;
};

export const TimeoutBar: FC<TimeoutBarProps> = ({ className, duration, inProgress }) => {
    return (
        <div className={className}>
            <div
                className={classnames(stylesheet.bar)}
                style={{
                    transition: `width ${duration}ms linear`,
                    width: `${inProgress ? 0 : 100}%`,
                }}
            />
        </div>
    );
};
